<template>
<div>
  <top-header></top-header>
<main-menu></main-menu>
<!-- Start the code for this screen here -->
<div class="pagecontainer">

    <div class="heading"><span><b>Help</b></span></div>

    </div>
  <!-- End of the code for this screen here -->
   <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  }
}
</script>
<style scoped>
</style>
